"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateThemesFromContent = void 0;
var types_1 = require("../types");
var utils_1 = require("../utils");
var generateFile_1 = require("./generateFile");
// TODO: Использовать этот метод вместо generateThemes
var generateThemesFromContent = function (theme) {
    var files = [];
    var indexContent = '';
    for (var _i = 0, _a = Object.entries(theme); _i < _a.length; _i++) {
        var _b = _a[_i], fileName = _b[0], content = _b[1];
        var lightTheme = "".concat(fileName, "__").concat(types_1.ColorMode.LIGHT);
        var darkTheme = "".concat(fileName, "__").concat(types_1.ColorMode.DARK);
        var colorsDarkContent = "".concat((0, utils_1.jsToCss)(content.dark, ':root'), "\n");
        var colorsLightContent = "".concat((0, utils_1.jsToCss)(content.light, ':root'), "\n");
        var typoContent = "\n".concat(content.typo.filter(Boolean).join('\n\n'), "\n");
        indexContent += "export { ".concat(lightTheme, " } from './").concat(lightTheme, "';\n");
        indexContent += "export { ".concat(darkTheme, " } from './").concat(darkTheme, "';\n");
        files.push((0, generateFile_1.generateFile)(lightTheme, "[`".concat(colorsLightContent + typoContent, "`] as unknown as TemplateStringsArray")), (0, generateFile_1.generateFile)(darkTheme, "[`".concat(colorsDarkContent + typoContent, "`] as unknown as TemplateStringsArray")));
    }
    files.push({
        file: 'index.ts',
        content: indexContent,
    });
    return files;
};
exports.generateThemesFromContent = generateThemesFromContent;
//# sourceMappingURL=generateThemesFromContent.js.map